import { FC } from "react";
import { Spin } from "antd";
import styled from "styled-components";

// Deliberately no `height: 100vh` — this renders inside a routed pane, not a full page. And no
// `.auth` variant: its `var(--main-gradient)` comes from the host's GlobalStyle, which a canary
// chunk cannot rely on.
const StyledLoaderContainer = styled.div`
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 48px 0;
`;

export const DashboardLoader: FC<{ className?: string }> = ({ className }) => (
  <StyledLoaderContainer className={className}>
    <Spin size="large" />
  </StyledLoaderContainer>
);

export default DashboardLoader;
